var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-down0830",attrs:{"id":"moreApp"}},[_c('a',{staticClass:"down-a",on:{"click":_vm.jieliuF}},[_vm._v("更多精彩内容下载APP")])])}
var staticRenderFns = []

export { render, staticRenderFns }